__turbopack_context__.v({
  "category": "u4UVEa_category",
  "grid": "u4UVEa_grid",
  "grid_0": "u4UVEa_grid_0",
  "grid_1": "u4UVEa_grid_1",
  "grid_2": "u4UVEa_grid_2",
  "grid_3": "u4UVEa_grid_3",
  "grid_4": "u4UVEa_grid_4",
  "grid_5": "u4UVEa_grid_5",
  "grid_6": "u4UVEa_grid_6",
  "logo__bottom": "u4UVEa_logo__bottom",
  "newsletter": "u4UVEa_newsletter",
  "sanity": "u4UVEa_sanity",
});
